<!--
 * @description: 字典类别
 * @param: 
 * @return: 
-->
<template>
	<div class="user-management-container">
		<tabel-panel  
			ref="tabel" :rowTemplate="rowTemplate" api="DadicInfoSearchsType"  
			:condition="conditionData" editType="pop" :autoSearch="true"
			@popConfirmButtonClick="popConfirmButtonClick" :clickRowSelected="false">
			
			<template v-slot:tabelTitleLeft>
				<div>字典类别列表</div>
			</template>
			<template v-slot:tabelTitleRight>
				<add-button @buttonClick="addPower">新增</add-button>
			</template>
			<template v-slot:condition>
				<text-field
					v-model:value="conditionData.Dic_Text" 
					labelText="字典类别名称:" 
					class="condition-container-input">
				</text-field>
			</template>
			<template v-slot:oprator="$opData">
				<div class="opration">
					<del-button class="item"
						:useConfirm="true" comfirmMessage="确定删除吗？" 
						comfirmOkText="确定" comfirmCancelText="取消" 
						@buttonClick="delSingleUser($opData.data)">删除</del-button>
				</div>
			</template>
			
		</tabel-panel>
	</div>
</template>

<script>
	import textField from "@/components/textField.vue"
	import delButton from "@/components/delButton.vue"
	import addButton from "@/components/addButton.vue"
	import tabelPanel from "@/components/tabelPanel.vue"
	import tableApi from "@/api/tabel.js"
	import {
			dictionaryEdit,
			dictionaryDel,
			DadicInfoSearchsTypeAdd
		} from "@/api/index.js"
	
	import {
		errMsg,
		successMsg
	} from "@/notify/index.js"

	export default {
		name: "dictionaryType",
		components: {
			textField,
			addButton,
			delButton,
			tabelPanel
		},
		data() {

			return {
				rowTemplate: [ {
						headerLabel: "字典类别名称",
						dataIndex: "Name",
						requird: true,
						showInDetail: false,
						editType: 'text',
						renderToHtml: true,
						sortable: true
					}, {
						headerLabel: '字典类别',
						showInList: false,
						editable: true,
						editType: 'text',
						dataIndex: 'Name',
						rules: [{
							required: true,
							message: "请输入字典类别"
						}]
					},{
						headerLabel: "备注",
						dataIndex: "Appendix",
						requird: true,
						showInDetail: false,
						editType: 'text',
						renderToHtml: true
					},{
						headerLabel: '备注',
						showInList: false,
						editable: true,
						editType: 'text',
						dataIndex: 'Appendix'
					}],
				conditionData: {
					Dic_Text: ''
				}
			}
		},
		methods: {
   /**
    * @description: 获取下拉框数据
    * @param {*}
    * @return {*}
    */			
			async selectOuguName()  {
				let source = await tableApi.dictionarySelectList({});
				if (source.code == 0) {
					let data = source.data.list.map(({
						DicId,
						Name
					}) => {
						return {
							label: Name,
							value: DicId
						}
					})
					let total = 0;
			
					return {
						total,
						data
					}
				} else {
					errMsg(this, source.message)
				}
			},
			reloadData() {
				this.$refs.tabel.reloadData()
			},
			//单列表删除
			delSingleUser({
				row
			}) {
				dictionaryDel({Id:row.id}).then(data => {
					if (data.code == 0) {
						successMsg(data.message)
						this.reloadData()
					} else {
						errMsg( data.message)
					}
				})
			},
			//弹层事件
			popConfirmButtonClick({
				slotData
			}) {
				console.log(slotData)
				// slotData.ParentId=1
				if( slotData.id === null ){
					slotData.id = 0
				}
				if (slotData.id) {
					slotData = JSON.stringify(slotData)
					DadicInfoSearchsTypeAdd({data: slotData}).then(data => {
						if (data.code == 0) {
							successMsg(data.message)
							this.reloadData()
							this.$refs.tabel.closeDialog()
						} else {
							errMsg(data.message)
						}
					})
				} else {
					slotData = JSON.stringify(slotData)
					DadicInfoSearchsTypeAdd({data: slotData}).then(data => {
						if (data.code == 0) {
							successMsg(data.message)
							this.reloadData()
							this.$refs.tabel.closeDialog()
						} else {
							errMsg(data.message)
						}
					})
				}
				
			},
			addPower() {
				this.$refs.tabel.showDialog(null, "新增")
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";

	#suerSwitch .el-switch__core{
		width: 26px;
	}
	
	.user-management-container {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		overflow: hidden;
		align-items: center;
		align-content: center;
		@include background_color("user-management-bg-color");

		.del {
			margin-left: 10px;
		}

		.condition-container-input {
			width: 270px;
		}

		.opration {
			height: 100%;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			align-content: center;

			.item {
				&:nth-child(n+1) {
					margin-left: 10px;
				}
			}
		}
		
		.menuPowerBOX{
			.el-button--default{
				width:90px;
				height:30px;
				color: #ffffff;
				background: rgb(100,134,232);
				border-radius: 4px;
			}
			.item {
				height: 30px;
				color: #ffffff !important;
				padding:10px 15px !important;
				background: rgb(100,134,232) !important; 
			}
		}
		.oprationTree{
			height: 300px;
			overflow: auto;
		}
		
	}
</style>
